import { isDateValidAndPast } from 'src/components/oneCorp/features/MealCredit/utils/isDateValidAndPast';

/**
 * Generates the refresh text based on the expiration date.
 *
 * @param expirationDate - The expiration date to evaluate.
 * @returns A string describing the refresh status.
 */
export function getRefreshText(expirationDate: Date): string {
  const refreshWord = isDateValidAndPast(expirationDate)
    ? 'Refreshed'
    : 'Refreshes';

  return `${refreshWord} every`;
}
